import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory<HTMLDivElement>()({
  targets: {
    checkButton: HTMLButtonElement,
    errorMessage: HTMLDivElement,
    form: HTMLFormElement,
    input: HTMLInputElement,
    submitButton: HTMLButtonElement,
    successMessage: HTMLDivElement,
  },
  values: {
    errorTitle: String,
    https: String,
    noResponse: String,
    successResponse: String,
    successTitle: String,
    internalEndpoint: String,
  },
}) {
  private runCheck() {
    const url = this.inputTarget.value;
    const errorMessageContainer = this.errorMessageTarget.querySelector(
      "[data-flash-target='message']",
    )! as HTMLParagraphElement;
    const errorTitleContainer = this.errorMessageTarget.querySelector(
      "[data-flash-target='title']",
    )! as HTMLParagraphElement;

    if (!url.startsWith("https://")) {
      errorTitleContainer.textContent = this.errorTitleValue;
      errorMessageContainer.textContent = this.httpsValue;

      this.showErrorMessage();
    } else {
      this.checkButtonTarget.disabled = true;
      this.hidAllMessages();

      const el = document.querySelector("meta[name='csrf-token']");
      const token = el?.getAttribute("content") || "";
      const tokenValue = this.formTarget.querySelector(
        "[data-url-check-token-value]",
      )!.value;

      const data = { signing_secret: tokenValue, url };
      fetch(this.internalEndpointValue, {
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
        },
        method: "POST",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          return response.json();
        })
        .then((response) => {
          if (response.status == "failed") {
            errorTitleContainer.textContent = this.errorTitleValue;
            errorMessageContainer.textContent = this.noResponseValue;

            this.showErrorMessage();
          } else if (response.status == "ok") {
            this.showSuccessMessage();
          }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => {
          this.checkButtonTarget.removeAttribute("disabled");
        });
    }
  }

  connect() {
    this.inputTarget.addEventListener("beforeinput", () => {
      this.submitButtonTarget.disabled = true;
    });
  }

  hidAllMessages() {
    this.errorMessageTarget.classList.add("opacity-0");
    this.successMessageTarget.classList.add("hidden");
  }
  showErrorMessage() {
    this.submitButtonTarget.disabled = true;
    this.successMessageTarget.classList.add("hidden");
    this.successMessageTarget.classList.remove("opacity-0");
    this.errorMessageTarget.classList.remove("hidden");
    this.errorMessageTarget.classList.remove("opacity-0");
  }

  showSuccessMessage() {
    this.submitButtonTarget.removeAttribute("disabled");
    this.errorMessageTarget.classList.add("hidden");
    this.errorMessageTarget.classList.remove("opacity-0");
    this.successMessageTarget.classList.remove("hidden");
  }
}
